import { Button, Form, InputGroup } from 'react-bootstrap'
import { Eye, EyeOff } from 'lucide-react'

export default function Password(props) {

    const { label_name, placeholder, disabled, name, value, onChange, onBlur, error, mandatory, reference, tabIndex, showPassword, setShowPassword } = props

    return (
        <>
            <Form.Group className="mb-2" controlId={name}>
                <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{`${label_name}${mandatory ? '*' : ''}`}</Form.Label>
                <InputGroup>
                    <Form.Control
                        ref={reference}
                        type={showPassword ? 'text' : 'password'}
                        size="sm"
                        placeholder={placeholder}
                        disabled={disabled}
                        className='form_input'
                        name={name}
                        value={value}
                        onChange={onChange}
                        onBlur={onBlur}
                        tabIndex={tabIndex}
                    />
                    <Button variant="outline-secondary" size='sm' onClick={() => setShowPassword(!showPassword)}>
                        {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                    </Button>
                </InputGroup>
                {error}
            </Form.Group>
        </>
    )
}
